import { CaseGranulometry } from '../../CaseGranulometry';
import { LevelGranulometry } from '../../../levels/LevelGranulometry';

export const getCaseLevels = (caseGranulometry: CaseGranulometry): LevelGranulometry[] => [
  ...caseGranulometry.levels
];
